import React from 'react';
import CategoryOverviewRender from '../../components/CategoryOverviewRender';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { yearChange } from '../../actions'

class CategoryOverview extends React.Component {

  render() {
    const { t } = this.props.t;

    //Gather categories and put into object with value of 0
    let categoryList;
    let category = [];
    if (this.props.category) {
      categoryList = Object.entries(this.props.category)
        .map( category =>
          category[1].name
        )
      categoryList.map( item =>
        category.push({'name': item, value: 0})
      )
    }

    //Assign values (amount/category)
    if (this.props.logs && categoryList) {
      let allLogs = Object.entries(this.props.logs)
      let logsPerStudent = {}
      categoryList.map( (item, index) => {
        let count = allLogs.filter( log =>
          log[1].atl_category.name == item
          )
        count = count.length
        category[index].value = count
        }
      )
    }

    return (
      <CategoryOverviewRender
        distribution={category}
        amount={category}
        categoryList={categoryList}
        t={this.props.t}
        currentYear={this.props.currentYear}
        changeYear={this.props.changeYear}
        allYears={this.props.allYears}
        gradeSelected={this.props.gradeSelected}
      />
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'students', 'atl_category'
    ]
  }),
  connect(
    state => ({
      studentFilter: state.studentFilter,
      logs: state.relevantLogs.logs,
      students: state.studentsOfSchool.students,
      category: state.firebase.data.atl_category,
      currentYear: state.currentYear,
      allYears: state.allYears && state.allYears.years,
      gradeSelected: state.selectedClass.id == 'All' ? false : true
    }),
    {changeYear: yearChange}
  )
)
export default enhancer(CategoryOverview);

const distribution = [
  {name: 'Social', value: 20},
  {name: 'Thinking', value: 20},
  {name: 'Research', value: 4},
  {name: 'Communication', value: 16},
  {name: 'Self-Management', value: 40}
]



// WEBPACK FOOTER //
// ./src/containers/CategoryOverview/index.jsx